var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('logout-header'):_vm._e(),_c('div',{attrs:{"id":"splash"}},[(_vm.error)?_c('fetch-error',{attrs:{"error":_vm.error},on:{"retry":function($event){return _vm.fetchData()}}}):_c('loader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }